import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import formats from '../../../../const/formats';
import {Loader} from '../../../components/Loader/Loader';
import getContentWithChunks from '../../../../services/mini/getContentWithChunks';
import { AnalyticsSimpleTile } from '../AnalyticsSimpleTile/AnalyticsSimpleTile';
import { AnalyticsPopupTile } from '../AnalyticsPopupTile/AnalyticsPopupTile';
import { AutoSizer, Column, SortDirection, Table } from 'react-virtualized';
import VirtualizedTable from './VirtualizedTable';
import { AnalyticsSimpleTileCollapser } from '../AnalyticsSimpleTile/AnalyticsSimpleTileCollapser';

class AnalyticUsersTile extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            users: this.getUsers(props),
        };
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.report?.data?.usersAndDialogsDataUpdateTs !== nextProps.report?.data?.usersAndDialogsDataUpdateTs) {
            return true;
        }
        if (this.props.selectedUserId !== nextProps.selectedUserId) {
            return true;
        }
        if (JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)) {
            return true;
        }

        return false;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ users: this.getUsers(nextProps) });
    }

    getUsers = (props) => {
        return props.report?.data?.users;
    }

    selectUser = ({ rowData: user }) => {
        const { selectUser, selectedUserId } = this.props;
        const userId = user.uuid;
        const platform = user.platform;
        selectUser(userId !== selectedUserId ? userId : null, platform);
    }

    render() {
        const {
            environment,
            selectedUserId,
            selectedPlatform
        } = this.props;

        const {
            users,
        } = this.state;

        return (
            <AnalyticsSimpleTile {...this.props} >
                <div className={`analytic-users-tile ${environment}`}>
                    <AnalyticsSimpleTileCollapser {...this.props}>
                        <div className="analytic-users-tile_header">
                            Users with dialogs: <div className="analytic-users-tile_total">{(users && users.length > 0) ? `${users.length}` : '—'}</div>
                        </div>
                    </AnalyticsSimpleTileCollapser>
                    {users ?
                        <div className="analytic-users-tile_body">
                            {users.length > 0 ?
                                <VirtualizedTable
                                    className="analytics-table"
                                    headerClassName="analytics-table_header-cell"
                                    getRowClassName={(user) => {
                                        return `${(selectedUserId === user?.uuid && selectedPlatform === user?.platform) && 'selected'}`;
                                    }}
                                    sortBy="lastConnectionTs"
                                    width={900}
                                    sortDirection={SortDirection.DESC}
                                    onRowClick={this.selectUser}
                                    data={users}
                                    columns={[
                                        {
                                            dataKey: 'platform',
                                            colName: 'Platform',
                                            sortable: true,
                                            className: 'semibold to-left',
                                            headerClassName: 'to-left',
                                            width: 80,
                                        },
                                        {
                                            dataKey: 'lastConnectionTs',
                                            colName: 'Last connection',
                                            sortable: true,
                                            formatter: (user) => {
                                                return <React.Fragment>
                                                    <span className="analytics-table_date">{moment(+user.lastConnectionTs).format(formats.logTs_date)},</span>
                                                    <span className="analytics-table_time">{moment(+user.lastConnectionTs).format(formats.logTs_time)}</span>
                                                </React.Fragment>;
                                            },
                                            className: 'to-left',
                                            headerClassName: 'to-left',
                                            width: 110,
                                        },
                                        {
                                            dataKey: 'location',
                                            colName: 'Location',
                                            sortable: true,
                                            className: 'semibold to-left',
                                            headerClassName: 'to-left',
                                            width: 110,
                                        },
                                        {
                                            dataKey: 'numOfDialogs',
                                            colName: () => {
                                                return <i className="icon-alan-stat-dialogs dialogs-icon" title="Dialogs" />;
                                            },
                                            sortable: true,
                                            width: 36,
                                            headerClassName: "to-center",
                                            className: "to-center"
                                        },
                                        {
                                            dataKey: 'recognized',
                                            colName: () => {
                                                return <i className="icon-alan-input-sign recognized-icon" title="Recognised"></i>;
                                            },
                                            sortable: true,
                                            width: 36,
                                            headerClassName: "to-center",
                                            className: "to-center",
                                            formatter: (user) => {
                                                return user.recognized || '—';
                                            }
                                        },
                                        {
                                            dataKey: 'unrecognized',
                                            colName: () => {
                                                return <i className="icon-alan-input-sign unrecognized-icon" title="Unrecognised"></i>;
                                            },
                                            sortable: true,
                                            width: 36,
                                            headerClassName: "to-center",
                                            className: "to-center",
                                            formatter: (user) => {
                                                return user.unrecognized || '—';
                                            }
                                        },
                                        {
                                            dataKey: 'errors',
                                            colName: () => {
                                                return <i className="icon icon-alan-remove-sign error-icon" title="Errors"></i>;
                                            },
                                            sortable: true,
                                            width: 36,
                                            headerClassName: "to-center",
                                            className: "to-center",
                                            formatter: (user) => {
                                                return user.errors || '—';
                                            }
                                        },
                                        {
                                            dataKey: 'lastRequest',
                                            colName: 'Last request',
                                            className: `${this.props.mode ? '' : 'last-request-users to-left'}`,
                                            headerClassName: "to-left",
                                            sortable: true,
                                            width: 300,
                                            formatter: (user) => {
                                                return <span dangerouslySetInnerHTML={getContentWithChunks(user.lastRequest, user.lastRequestEnts, 'highlighted-text-in-logs')}></span>;
                                            }
                                        },
                                    ]}
                                /> : <div className="analytic-users-tile_no-data">Not enough data to show this report.</div>}
                        </div> :
                        <Loader theme="dark" size="small" center={true} />}
                </div>
            </AnalyticsSimpleTile>
        );
    }
}


export default AnalyticsPopupTile(AnalyticUsersTile);
